import { Component, HostListener, OnInit, Renderer2 } from '@angular/core';
import { dataUser } from '../../models';
import { AuthService } from '@auth0/auth0-angular';
declare var $: any;

@Component({
  standalone: false,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {
  public isCollapsed = true;
  public dataUser: dataUser;
  public dataUserStorage: any = sessionStorage.getItem("dataUser");

  constructor(
    private authService: AuthService,
    private renderer: Renderer2,
  ) {
    this.dataUser = JSON.parse(this.dataUserStorage);
  }

  ngOnInit(): void {
    if (window.innerWidth <= 768) {
      $(".page-wrapper").removeClass("toggled");
    }
  }

  ngAfterViewInit(): void {
    this.renderer.listen("document", "click", (event) => {
      if (event.target.hasAttribute("eliminar_overlay")) {
        this.closeSidebar();
      }
    });
  }

  public toggleSidebar() : void {
    if ($(".page-wrapper").hasClass("toggled")) {
      if (window.innerWidth >= 768) {
        $(".page-wrapper").removeClass("toggled");
      } else {
        this.closeSidebar();
      }
    } else {
      if (window.innerWidth >= 768) {
        $(".page-wrapper").addClass("toggled");
      } else {
        this.openSidebar();
      }
    }
  }

  public openSidebar() : void {
    $(".page-wrapper").addClass("toggled");
    $(".page-wrapper").append(`<div class="overlay-sidebar" eliminar_overlay></div>`);
  }

  public closeSidebar() : void {
    $(".overlay-sidebar").remove();
    $(".page-wrapper").removeClass("toggled");
  }

  public cerrarSesion() : void {
    sessionStorage.clear();
    this.authService.logout({ logoutParams: { returnTo: window.location.origin } });
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: Event): void {
    if (window.innerWidth <= 768) {
      $(".page-wrapper").removeClass("toggled");
    } else {
      $(".page-wrapper").addClass("toggled");
    }
  }
}